import { ReactComponent as IconPlus } from "../../../styles/assets/svg/icon_foodPlus.svg";
import { ReactComponent as IconMinus } from "../../../styles/assets/svg/icon_foodMinus.svg";
import { ReactComponent as IconPillImg } from "../../../styles/assets/svg/icon_pill_img.svg";
import { InputTextarea } from "src/components/atoms/Inputs/InputTextarea";
import { InputText } from "src/components/atoms/Inputs/InputText";
import { FallbackImage } from "src/pages/diet/DietPage";
import { useRef, useState } from "react";
import { showAlert } from "src/components/containers/Alert";

const oneDay = ["캡슐", "정", "ml"];
const pillPoint = ["식전", "식후", "기타"];

export const ChoicePillInfo = ({
  item,
  count,
  isOneDay,
  isPillPoint,
  imgFileUrl,
  setImgFileUrl,
  setCount,
  setIsOneDay,
  setIsPillPoint,
  memo,
  setMemo,
}: any) => {
  const [localPreview, setLocalPreview] = useState<any>("");
  const fileInputRef = useRef<HTMLInputElement | null>(null); // file ref

  // 파일 선택 핸들러
  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      if (file.type.startsWith("image/")) {
        const previewUrl = URL.createObjectURL(file); // 미리보기 URL
        setImgFileUrl({ filePath: previewUrl, file });
        setLocalPreview(previewUrl);
      } else {
        showAlert("이미지 파일만 업로드할 수 있습니다."); // or toast
      }

      e.target.value = ""; // 같은 파일 다시 선택 가능하게 초기화
    }
  };

  const increment = (count: number) => {
    setCount(count + 1);
  };

  const decrement = (count: number) => {
    setCount(count - 1);
  };
  return (
    <>
      <p>약 사진</p>
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "center",
        }}
      >
        <div
          style={{ width: "96px", height: "96px" }}
          onClick={() => {
            fileInputRef.current?.click(); // 파일창 열기;
          }}
        >
          <input
            type="file"
            accept="image/*" // img만 업로드 가능
            style={{ display: "none" }}
            ref={fileInputRef}
            onChange={handleFileChange}
          />
          {item?.fileUrl || localPreview ? (
            <FallbackImage
              src={
                localPreview
                  ? localPreview
                  : process.env.REACT_APP_API_FILE + item.fileUrl
              }
              alt={item?.mediName || ""}
            />
          ) : (
            <IconPillImg />
          )}
        </div>
      </div>
      <p>1회 복용량</p>
      <div
        style={{
          width: "100%",
          flex: "1 1 0",
          padding: "14px 12px",
          boxShadow: "0px 4px 11px rgba(0, 0, 0, 0.04)",
          borderRadius: 8,
          outline: "1px var(--neutral-100, #F5F5F5) solid",
          outlineOffset: "-1px",
          justifyContent: "space-between",
          alignItems: "center",
          display: "flex",
        }}
      >
        <IconMinus
          style={{ cursor: "pointer" }}
          onClick={() => decrement(count)}
        />
        <div
          style={{
            justifyContent: "center",
            display: "flex",
            flexDirection: "column",
            color: "var(--neutral-600, #525252)",
            fontSize: 14,
            fontWeight: "500",
            lineHeight: "20px",
          }}
        >
          {/* {pill.qty ?? 1} */}
          {count}
        </div>
        <IconPlus
          style={{ cursor: "pointer" }}
          onClick={() => increment(count)}
        />
      </div>
      <div
        style={{
          width: "100%",
          display: "grid",
          gridTemplateColumns: "repeat(3, 1fr)",
          gap: 8,
        }}
      >
        {oneDay.map((oneDay) => {
          const active = isOneDay === oneDay;
          return (
            <div
              key={oneDay}
              onClick={() => {
                setIsOneDay(oneDay);
              }}
              style={{
                width: "100%",
                height: "40px",
                background: active
                  ? "var(--neutral-700, #404040)"
                  : "var(--neutral-100, #F5F5F5)",
                borderRadius: 8,
                justifyContent: "center",
                alignItems: "center",
                gap: 10,
                display: "flex",
                transition: "background-color 0.3s ease, color 0.3s ease",
                cursor: "pointer",
              }}
            >
              <div
                style={{
                  color: active ? "white" : "var(--neutral-700, #404040)",
                  fontSize: 16,
                  fontWeight: "500",
                  lineHeight: "24px",
                }}
              >
                {oneDay || 1}
              </div>
            </div>
          );
        })}
      </div>
      <p>복용 시점</p>
      <div
        style={{
          width: "100%",
          display: "grid",
          gridTemplateColumns: "repeat(3, 1fr)",
          gap: 8,
        }}
      >
        {pillPoint.map((pillPoint) => {
          const active =
            isPillPoint === pillPoint ||
            (pillPoint === "기타" &&
              isPillPoint !== null &&
              isPillPoint !== "식전" &&
              isPillPoint !== "식후");
          return (
            <div
              key={pillPoint}
              onClick={() => {
                setIsPillPoint(pillPoint);
              }}
              style={{
                width: "100%",
                height: "40px",
                background: active
                  ? "var(--neutral-700, #404040)"
                  : "var(--neutral-100, #F5F5F5)",
                borderRadius: 8,
                justifyContent: "center",
                alignItems: "center",
                gap: 10,
                display: "flex",
                transition: "background-color 0.3s ease, color 0.3s ease",
                cursor: "pointer",
              }}
            >
              <div
                style={{
                  color: active ? "white" : "var(--neutral-700, #404040)",
                  fontSize: 16,
                  fontWeight: "500",
                  lineHeight: "24px",
                }}
              >
                {pillPoint}
              </div>
            </div>
          );
        })}
      </div>
      {isPillPoint !== null &&
        isPillPoint !== "식전" &&
        isPillPoint !== "식후" && (
          <InputText
            name="isPillPoint"
            size="lg"
            width={100}
            placeholder="ex) 운동 전"
            value={isPillPoint}
            onChange={(e: any) => setIsPillPoint(e.target.value)}
          />
        )}

      <p>메모</p>
      <InputTextarea
        name="memo"
        size="lg"
        width={100}
        height={128}
        placeholder="특이사항이 있다면 적어주세요."
        value={memo}
        onChange={(e: any) => setMemo(e.target.value)}
      />
    </>
  );
};
